/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Point a connection's future intake at another tenant pool of the org.
 */
export interface ConnectionTalentPoolPatch {
  talent_pool_id: string;
}
